<template>
  <div class="row">
    <div class="col-md-12">
      <b-card no-body>
        <b-tabs pills card vertical>
          <b-tab title="Tipos de Lançamento" active>
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <b-form-checkbox-group
                    id="all_types_of_entries_ids"
                    v-model="all_types_of_entries_ids"
                    :options="[{ value: 'TODOS', text: 'TODOS' }]"
                    name="all_types_of_entries_ids"
                    @input="handleAllTypesOfEntriesIds"
                  />
                  <b-form-checkbox-group
                    id="types_of_entries_ids"
                    v-model="types_of_entries_ids"
                    :options="types_of_entries"
                    name="types_of_entries_ids"
                  />
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Categorias">
            <div class="row">
              <div class="col-md-12">
                <treeselect
                  multiple
                  flat
                  :options="finance_configuration_category"
                  placeholder="SELECIONE..."
                  v-model="finance_configuration_category_ids"
                  noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Formas de Pagamento">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <b-form-checkbox-group
                    id="finance_configuration_payment_methods_ids"
                    v-model="finance_configuration_payment_methods_ids"
                    name="finance_configuration_payment_methods_ids"
                    class="pl-5"
                  >
                    <div class="row m-0">
                      <b-form-checkbox value="NONE" class="col-md-6 p-0 m-0"
                        >Sem forma de pagamento</b-form-checkbox
                      >
                      <b-form-checkbox
                        class="col-md-6 p-0 m-0"
                        v-for="(
                          item, key
                        ) in finance_configuration_payment_methods"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.description }}
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Custos">
            <div class="row">
              <div class="col-md-6">
                <h6>Tipo de Custo Nível de Produção</h6>
                <b-form-group>
                  <b-form-checkbox-group
                    id="cost_types_ids"
                    v-model="cost_types_ids"
                    :options="[
                      { value: 'NONE', description: 'Sem tipo de custo' },
                      ...cost_types,
                    ]"
                    name="cost_types_ids"
                    text-field="description"
                    value-field="value"
                    stacked
                  />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <h6>Tipo de Custo de Apropriação do Produto</h6>
                <b-form-group>
                  <b-form-checkbox-group
                    id="cost_appropriations_ids"
                    v-model="cost_appropriations_ids"
                    :options="[
                      {
                        value: 'NONE',
                        description: 'Sem tipo de apropriação de custo',
                      },
                      ...cost_appropriations,
                    ]"
                    name="cost_appropriations_ids"
                    text-field="description"
                    value-field="value"
                    stacked
                  />
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Centro de custo/lucro">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <b-form-checkbox-group
                    id="finance_configuration_profit_cost_center_ids"
                    v-model="finance_configuration_profit_cost_center_ids"
                    :options="[
                      { id: 'NONE', description: 'Sem centro de custo/lucro' },
                      ...finance_configuration_profit_cost_center,
                    ]"
                    name="finance_configuration_profit_cost_center_ids"
                    text-field="description"
                    value-field="id"
                    stacked
                  />
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Tipos de Documentos">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <b-form-checkbox-group
                    id="finance_configuration_document_types_ids"
                    v-model="finance_configuration_document_types_ids"
                    :options="[
                      { id: 'NONE', description: 'Sem documento fiscal' },
                      ...finance_configuration_document_types,
                    ]"
                    name="finance_configuration_document_types_ids"
                    text-field="description"
                    value-field="id"
                    stacked
                  />
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Clientes">
            <div class="row">
              <div class="col-md-12 p-0">
                <input
                  type="text"
                  class="form-control"
                  v-model="filter_finance_client"
                  @input="handleFilterFinanceClient($event.target.value)"
                  placeholder="Pesquisar cliente..."
                />
              </div>
              <div
                class="col-md-12 pt-0 pb-0"
                style="height: 300px; overflow-y: scroll"
              >
                <b-form-group>
                  <b-form-checkbox-group
                    id="finance_client_ids"
                    v-model="finance_client_ids"
                    name="finance_client_ids"
                    class="pl-5"
                  >
                    <div class="row m-0">
                      <b-form-checkbox
                        value="NONE"
                        class="col-md-6 p-0 m-0 text-thirteen"
                        >Sem cliente</b-form-checkbox
                      >
                      <b-form-checkbox
                        class="col-md-6 p-0 m-0 text-thirteen"
                        v-for="(item, key) in finance_clients"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Fornecedores">
            <div class="row">
              <div class="col-md-12 p-0">
                <input
                  type="text"
                  class="form-control"
                  v-model="filter_finance_client"
                  @input="handleFilterProvider($event.target.value)"
                  placeholder="Pesquisar fornecedor..."
                />
              </div>
              <div
                class="col-md-12 pt-0 pb-0"
                style="height: 300px; overflow-y: scroll"
              >
                <b-form-group>
                  <b-form-checkbox-group
                    id="provider_ids"
                    v-model="provider_ids"
                    name="provider_ids"
                    class="pl-5"
                  >
                    <div class="row m-0">
                      <b-form-checkbox
                        value="NONE"
                        class="col-md-6 p-0 m-0 text-thirteen"
                        >Sem fornecedor</b-form-checkbox
                      >
                      <b-form-checkbox
                        class="col-md-6 p-0 m-0 text-thirteen"
                        v-for="(item, key) in provider"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.company_name }}
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Tags">
            <div class="row">
              <div class="col-md-12">
                <b-form-group>
                  <b-form-checkbox-group
                    id="finance_configuration_tag_ids"
                    v-model="finance_configuration_tag_ids"
                    :options="[
                      { id: 'NONE', description: 'Sem tag' },
                      ...finance_configuration_tag,
                    ]"
                    name="finance_configuration_tag_ids"
                    text-field="description"
                    value-field="id"
                    stacked
                  />
                </b-form-group>
              </div>
            </div>
          </b-tab>
          <b-tab title="Usuários">
            <div class="row">
              <div class="col-md-12 p-0">
                <input
                  type="text"
                  class="form-control"
                  v-model="filter_user"
                  @input="handleFilterUser($event.target.value)"
                  placeholder="Pesquisar usuário..."
                />
              </div>
              <div class="col-md-12" style="height: 300px; overflow-y: scroll">
                <b-form-group>
                  <b-form-checkbox-group
                    id="users_ids"
                    v-model="users_ids"
                    name="users_ids"
                    class="pl-5"
                  >
                    <div class="row m-0">
                      <b-form-checkbox
                        class="col-md-6 p-0 m-0 text-thirteen"
                        v-for="(item, key) in user"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 pt-0 pb-0 text-right">
      <v-btn @click="handleEmitCancel" :disabled="loading" class="btn-cancel">
        {{ loading ? "CARREGANDO" : "CANCELAR" }}
      </v-btn>
      <v-btn @click="handleEmit" :disabled="loading" class="ml-2 btn-filter">
        <i class="fas fa-filter mr-2 text-twenty"></i>
        {{ loading ? "CARREGANDO" : "FILTRAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "Filters",
  components: {
    ErrorsMessages,
    Treeselect,
  },
  props: {
    users: Array,
    providers: Array,
    finance_client: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    filters: Object,
    cost_appropriations: { type: Array, default: () => [] },
    cost_types: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      filter_user: "",
      filter_category: "",
      filter_finance_client: "",
      filter_provider: "",
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],
      finance_clients: [],
      provider: [],
      user: [],
      items: [
        {
          id: 1,
          name: "Applications :",
          children: [
            { id: 2, name: "Calendar : app" },
            { id: 3, name: "Chrome : app" },
            { id: 4, name: "Webstorm : app" },
          ],
        },
      ],
      types_of_entries_ids: [],
      all_types_of_entries_ids: [],
      types_of_entries: [
        { text: "Pagos", value: "PAGOS" },
        { text: "Contas a pagar", value: "CONTAS_A_PAGAR" },
        { text: "Contas a pagar atrasados", value: "CONTAS_A_PAGAR_ATRASADAS" },
        {
          text: "Desconsiderar transferências",
          value: "DESCONSIDERAR_TRANSFERENCIAS",
        },
        { text: "Recebidos", value: "RECEBIDOS" },
        { text: "Contas a receber", value: "CONTAS_A_RECEBER" },
        {
          text: "Contas a receber atrasados",
          value: "CONTAS_A_RECEBER_ATRASADAS",
        },
      ],
      errors: [],
    };
  },
  created() {
    this.finance_clients = this.finance_client;
    this.provider = this.providers;

    this.user = this.users;

    let {
      types_of_entries_ids,
      users_ids,
      provider_ids,
      finance_client_ids,
      finance_configuration_document_types_ids,
      finance_configuration_payment_methods_ids,
      finance_configuration_category_ids,
      finance_configuration_profit_cost_center_ids,
      finance_configuration_tag_ids,
      cost_types_ids,
      cost_appropriations_ids,
    } = this.filters;

    this.types_of_entries_ids = types_of_entries_ids;
    this.users_ids = users_ids;
    this.provider_ids = provider_ids;
    this.finance_client_ids = finance_client_ids;
    this.finance_configuration_document_types_ids =
      finance_configuration_document_types_ids;
    this.finance_configuration_payment_methods_ids =
      finance_configuration_payment_methods_ids;
    this.finance_configuration_category_ids =
      finance_configuration_category_ids;
    this.finance_configuration_profit_cost_center_ids =
      finance_configuration_profit_cost_center_ids;
    this.finance_configuration_tag_ids = finance_configuration_tag_ids;
    this.cost_types_ids = cost_types_ids;
    this.cost_appropriations_ids = cost_appropriations_ids;
  },
  methods: {
    handleAllTypesOfEntriesIds() {
      let { all_types_of_entries_ids, types_of_entries } = this;

      if (all_types_of_entries_ids.includes("TODOS")) {
        this.types_of_entries_ids = types_of_entries.map(
          (type_of_entries) => type_of_entries.value
        );
      } else {
        this.types_of_entries_ids = [];
      }
    },
    handleFilterUser(value) {
      let { users } = this;

      this.user = users.filter(
        ({ name }) =>
          String(name).toLowerCase().indexOf(String(value).toLowerCase()) > -1
      );
    },
    handleFilterFinanceClient(value) {
      let { finance_client } = this;

      this.finance_clients = finance_client.filter(
        ({ name }) =>
          String(name).toLowerCase().indexOf(String(value).toLowerCase()) > -1
      );
    },
    handleFilterProvider(value) {
      let { providers } = this;

      this.provider = providers.filter(
        ({ company_name }) =>
          String(company_name)
            .toLowerCase()
            .indexOf(String(value).toLowerCase()) > -1
      );
    },
    handleEmitCancel() {
      this.$emit("cancel");
    },
    handleEmit() {
      this.loading = true;
      let {
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
      } = this;

      this.$emit("success", {
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
      });

      this.loading = false;
    },
  },
};
</script>